import axios from 'axios';
import { AXIOS_CONFIG, API_CONFIGS, POST_TYPES, AXIOS_CONFIG_MAGIC_LINK, AXIOS_CONFIG_PDA_LITE } from '../configs';
import { ACTIONS } from './index';
import { planName } from '../configs/plan'

export function fetchUrls(postId) {
    let axiosInstance;
    if ( planName === 'lite') {
        axiosInstance = axios.create(AXIOS_CONFIG_PDA_LITE());
    } else {
        axiosInstance = axios.create(AXIOS_CONFIG());
    }

    const request = axiosInstance.get(API_CONFIGS.FETCH_PRIVATE_URLS(postId));

    return {
        type: ACTIONS.FETCH_URLS,
        payload: request
    }
}

export function newUrl(postId) {
    const url = API_CONFIGS.CREATE_PRIVATE_URLS(postId);
    const axiosInstance = axios.create(AXIOS_CONFIG());
    const request = axiosInstance.post(url);

    return {
        type: ACTIONS.CREATE_URLS,
        payload: request
    }
}

export function deleteUrl(id) {

    const url = API_CONFIGS.DELETE_PRIVATE_URL(id);
    const axiosInstance = axios.create(AXIOS_CONFIG());
    const request = axiosInstance.post(url);

    return {
        type: ACTIONS.DELETE_URLS,
        payload: request
    }
}

export function updateUrlStatus(id, is_prevented) {

    const url = API_CONFIGS.UPDATE_DATA_PRIVATE_URL(id);
    const axiosInstance = axios.create(AXIOS_CONFIG());
    const request = axiosInstance.post(url, {
        info: {
            'is_prevented' : !is_prevented
        }
    });

    return {
        type: ACTIONS.UPDATE_URLS,
        payload: request
    }

}

export function updateDataUrl(id, val) {

    const url = API_CONFIGS.UPDATE_DATA_PRIVATE_URL(id);
    const axiosInstance = axios.create(AXIOS_CONFIG());
    const data = {
        info: val
    }
    const request = axiosInstance.post(url, data);

    return {
        type: ACTIONS.UPDATE_URLS,
        payload: request
    }

}

export function addCustomUrl(postId, data) {
    const axiosInstance = axios.create(AXIOS_CONFIG());
    const request = axiosInstance.post(API_CONFIGS.CREATE_PRIVATE_URLS(postId), data);

    return {
        type: ACTIONS.CUSTOM_PRIVATE_URL,
        payload: request
    }
}

export function bulkAddCustomUrl(postId, data) {
    const axiosInstance = axios.create(AXIOS_CONFIG());
    const request = axiosInstance.post(API_CONFIGS.BULK_CREATE_PRIVATE_URLS(postId), data);

    return {
        type: ACTIONS.CUSTOM_PRIVATE_URL,
        payload: request
    }
}

export function protectThisFile(postId) {
    let axiosInstance;
    if ( planName === 'lite') {
        axiosInstance = axios.create(AXIOS_CONFIG_PDA_LITE());
    } else {
        axiosInstance = axios.create(AXIOS_CONFIG());
    }
    const request = axiosInstance.post(API_CONFIGS.PROTECT_FILE(postId));

    return {
        type: ACTIONS.PROTECT_FILE,
        payload: request
    }
}

export function unProtectThisFile(postId) {
    let axiosInstance;
    if ( planName === 'lite') {
        axiosInstance = axios.create(AXIOS_CONFIG_PDA_LITE());
    } else {
        axiosInstance = axios.create(AXIOS_CONFIG());
    }
    const request = axiosInstance.post(API_CONFIGS.UN_PROTECT_FILE(postId));

    return {
        type: ACTIONS.PROTECT_FILE,
        payload: request
    }
}

export function isItProtectedFile(postId) {
    let axiosInstance;
    if ( planName === 'lite') {
        axiosInstance = axios.create(AXIOS_CONFIG_PDA_LITE());
    } else {
        axiosInstance = axios.create(AXIOS_CONFIG());
    }
    const request = axiosInstance.get(API_CONFIGS.IS_PROTECTED_FILE(postId));

    return {
        type: ACTIONS.IS_PROTECTED_FILE,
        payload: request
    }
}

export function setDefault(id, postId) {
    const axiosInstance = axios.create(AXIOS_CONFIG());
    const request = axiosInstance.post(API_CONFIGS.SET_DEFAULT(id), {
        post_id: postId
    });

    return {
        type: ACTIONS.SET_DEFAULT,
        payload: request
    }
}

export function privateLinkUser(postId, data) {
    const axiosInstance = axios.create(AXIOS_CONFIG_MAGIC_LINK());
    const request = axiosInstance.post(API_CONFIGS.CREATE_PRIVATE_URL_USER(postId), data);

    return {
        type: ACTIONS.CREATE_URL_FOR_USER,
        payload: request
    }

}

export function getPrivateLinkUser(postId) {
    const axiosInstance = axios.create(AXIOS_CONFIG_MAGIC_LINK());
    const request = axiosInstance.get(API_CONFIGS.GET_PRIVATE_URL_USER(postId));

    return {
        type: ACTIONS.GET_URL_FOR_USER,
        payload: request
    }

}
